import { TopicType } from '@/types/assistant';

export const TOPIC_CONFIG: Record<TopicType, {
  label: string;
  color: string;
  bgColor: string;
  borderColor: string;
}> = {
  guide: {
    label: 'AI Guide',
    color: 'text-botscheme-royal-purple',
    bgColor: 'bg-botscheme-royal-purple/10',
    borderColor: 'border-botscheme-royal-purple/20'
  },
  performance: {
    label: 'Performance Analyst',
    color: 'text-botscheme-ocean-blue',
    bgColor: 'bg-botscheme-ocean-blue/10',
    borderColor: 'border-botscheme-ocean-blue/20'
  },
  trading_strategy: {
    label: 'Strategy Expert',
    color: 'text-botscheme-emerald-green',
    bgColor: 'bg-botscheme-emerald-green/10',
    borderColor: 'border-botscheme-emerald-green/20'
  },
  advisor: {
    label: 'Financial Advisor',
    color: 'text-botscheme-amber-gold',
    bgColor: 'bg-botscheme-amber-gold/10',
    borderColor: 'border-botscheme-amber-gold/20'
  }
};

// For backwards compatibility, keep CATEGORY_CONFIG as a reference to TOPIC_CONFIG
export const CATEGORY_CONFIG = TOPIC_CONFIG;
